import axios from "./axiosInstance";

const allProductsListingApi = {
  product_list: () => axios.post("allProductsListing"),

  details: (slug) => axios.post(`product-detail/${slug}`),
};

export default allProductsListingApi;
